import { useEffect, useState } from "react";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../firebase";
import { openServiceRequestStatuses } from "../utils/serviceRequests";

export default function ServiceRequestBadge({ enabled }) {
  const [count, setCount] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    setCount(null); setError(false);
    if (!enabled) return undefined;
    return onSnapshot(query(collection(db, "serviceRequests"), where("status", "in", openServiceRequestStatuses)), snap => {
      setCount(snap.docs.filter(doc => !doc.data().fulfillmentProvider).length); setError(false);
    }, failure => {
      console.error("Service request count unavailable:", failure);
      setError(true); setCount(null);
    });
  }, [enabled]);
  if (!enabled || count === 0 && !error) return null;
  const label = error ? "Request count unavailable. Open the queue to retry." : count === null ? "Loading request count" : `${count} unfinished service requests`;
  return <span className={`ml-2 inline-flex min-w-[1.5rem] items-center justify-center rounded-full px-2 text-xs font-semibold ${error ? "bg-red-100 text-red-800" : "bg-teal-100 text-teal-900"}`}
    role="status" aria-label={label} title={label}>{error ? "!" : count === null ? "..." : count}</span>;
}
